import { Card, InputTags } from 'components';
import { Button, InputWraper, useForm } from 'modules';
import React, { useState } from 'react';
import toast from 'react-hot-toast';

import { ExcelReader } from './Components';
import { filterOptions, type FilterType } from './config';
import { useTransactionIDBanksQuery } from 'services/transactionIDBanks';
import { checkValidActionRoleAdmin } from 'utils/helpers';
import { Actions } from 'configs/actions';

const ColumnKey = 'Mã giao dịch ngân hàng';

const RequestTransactionIDBanksFeatures = () => {
  const { mutateAsync, isLoading: isLoadingProcess } =
    useTransactionIDBanksQuery();

  const [readerCustomers, setReaderCustomers] = useState<string[]>();

  const handleFilter = async (e: FilterType) => {
    try {
      const data = await mutateAsync(e.transactionIDs.join(','));
      if (data?.statusCode === 200) {
        toast.success('Yêu cầu gửi lại Số dư hoàn tất');
      }
    } catch {}
  };

  const { getInputProps, handleSubmit } = useForm({
    structure: filterOptions,
    onSubmit: handleFilter,
  });

  const handleReaderCallback = (data: any) => {
    if (!data?.length) return;

    const transactionIDs = data.map((item: any) => {
      if (!Object.keys(item).includes(ColumnKey)) {
        toast.error('Tệp không đúng định dạng');
        return;
      }

      return item[ColumnKey];
    });

    setReaderCustomers(transactionIDs);
  };

  const handleKeyDown = (event: any) => {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  };

  return (
    <>
      <div className='textRight mb20'>
        <ExcelReader
          onReaderCallback={handleReaderCallback}
          classNames='ml10'
        />

        <a
          href={`${process.env.PUBLIC_URL}/assets/templates/Ma_giao_dich_ngan_hang.xlsx`}
          download
        >
          <Button
            label='Tải về tệp mẫu'
            type='button'
            buttonType='info-outline'
            className='ml10'
          />
        </a>
      </div>

      <Card className='container-fluid electric-bill-access mb20'>
        <form onSubmit={handleSubmit}>
          <div className='row'>
            <div className='col-lg-4 col-12'>
              <InputWraper
                label='Giao dịch Ngân hàng'
                isRequired
                inputProps={getInputProps('transactionIDs')}
                renderInput={(props) => (
                  <InputTags
                    {...props}
                    defaultValue={readerCustomers}
                    placeholder='Nhập mã giao dịch ngân hàng'
                    onKeyDown={handleKeyDown}
                  />
                )}
              />
            </div>
          </div>

          {checkValidActionRoleAdmin(Actions.TPBank_ResendTransaction) && <div className='textCenter mt16'>
            <Button
              label='Gửi lại biến động số dư'
              type='submit'
              buttonType='success'
              disabled={isLoadingProcess}
            />
          </div>}
        </form>
      </Card>
    </>
  );
};

export default RequestTransactionIDBanksFeatures;
